import {
  DataLabel,
  DataRow,
  DataRowWrapper,
  DataWrapper,
  Divider,
  Title,
  Wrapper,
  WrapperTitle,
} from './styles'

const DashCard = (props: any) => (
  <Wrapper>
    <WrapperTitle>
      <Title>{props.title || 'Title'}</Title>
    </WrapperTitle>

    <DataWrapper>
      {props.cardData &&
        props.cardData.map((data: any) => {
          return (
            <>
              <DataRowWrapper>
                <DataRow>
                  <DataLabel style={{ color: data.color }}>{data.name}</DataLabel>
                  <DataLabel style={{ color: data.color }}>{data.value}</DataLabel>
                </DataRow>
              </DataRowWrapper>

              <Divider />
            </>
          )
        })}
    </DataWrapper>

    {props.icon && (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '50px' }}>{props.icon}</div>
    )}
  </Wrapper>
)

export default DashCard
